import React from 'react'
import LinkIcon from './LinkIcon'
const WebsiteLink = ({ website }) => {
  const rel =
    'utm_medium=latercera&utm_source=interactivo-candidatos-constituyentes'
  return (
    <>
      {website && website.startsWith('http') && (
        <h4 className="py-4 leading-none truncate truncate-content sm:py-0 sm:mb-2">
          <a
            className="flex pt-2 align-baseline hover:text-azul hover:underline"
            href={
              website.includes('?')
                ? `${website}&${rel}&`
                : `${website}?${rel}&`
            }
            target="_blank">
            <LinkIcon className="inline-block w-4 h-4 mr-1 text-gray-500" />{' '}
            {website
              // .replace('http://', '')
              // .replace('https://', '')
              .replace('www.', '')}
          </a>
        </h4>
      )}
    </>
  )
}

export default WebsiteLink
